import {
  Box, Grid, makeStyles, SvgIcon, Typography, Hidden,
} from '@material-ui/core';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q1Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(2),
    },
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    definitionBox: {
      padding: theme.spacing(2),
      backgroundColor: `${primaryColor} !important`,
      color: '#fff !important',
    },
    questionBox: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    headline: {
      fontWeight: 'bold',
    },
  }))();

  return (
    <Grid
      container
      className={classes.root}
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          {/* <HelpIcon style={{ color: primaryColor, fontSize: 60 }} align="center" /> */}
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, do families have access to subsidized child care?
          </Typography>
          <Hidden only="xs">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={5}>
                <Box borderRadius={8} className={classes.definitionBox}>
                  <Typography variant="h5" align="center">Subsidized child care</Typography>
                  <SvgIcon style={{ fontSize: '5em' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 559.51 464.35">

                      <g fill="#FFF">
                        <rect x="186.44" y="89.33" width="118.33" height="11.25" rx="3.67" />
                        <path d="M188.16,46.15c4.21,10.35,8.79,21.35,9.61,32.5a4.45,4.45,0,0,0,4.4,4.18h87.39a4.43,4.43,0,0,0,4.4-4c1.46-14.77,7-29.33,12.16-43.27l.28-.77c.82-2.22-.91-5.23-3.19-4.58a22.32,22.32,0,0,0-4.68,2.69,12.78,12.78,0,0,1-5.5,2.25l-.37,0a12,12,0,0,1-8.43-2.35,16.33,16.33,0,0,0-9.1-3.48l-.56,0a18.16,18.16,0,0,0-6.9,1.35l-7.41,3a21.24,21.24,0,0,1-9,1.57H251a18.11,18.11,0,0,1-4.43-.87l-14.15-4.56a15.09,15.09,0,0,0-4.37-.77H228a15.51,15.51,0,0,0-5.87,1.08l-8.63,3.31a21.48,21.48,0,0,1-5.85,1.37,41.25,41.25,0,0,1-12.77-1,10.59,10.59,0,0,1-2.13-.76s-4.39-2.48-6-2.84c-2.36-.53-4.06,2.44-3.15,4.68Z" />
                        <path d="M257.93,242.85A34.64,34.64,0,0,0,250,238.2v19.32q10.54-1.78,10.55-9.16A7,7,0,0,0,257.93,242.85Z" />
                        <path d="M229.37,201.26a7.37,7.37,0,0,0,2.37,5.63,28.31,28.31,0,0,0,7.64,4.53V193.19Q229.38,194.66,229.37,201.26Z" />
                        <path d="M310.06,112a15,15,0,0,0-11.17-4.91h-.06c-26.93,0-80.79,0-107.71,0h0a15.17,15.17,0,0,0-11.28,5c-31.84,35-63.41,83.41-63.41,137.59C116.43,359,174,379.69,245,379.69S373.51,359,373.51,249.63C373.51,195.42,341.92,147,310.06,112ZM275,267q-8.92,7.49-25,9V291.9H239.38V276.3q-18.93-.39-33.21-6.68V249.14a89.89,89.89,0,0,0,16.26,5.9,87.51,87.51,0,0,0,16.95,3V234l-5.19-2q-15.37-6.06-21.77-13.15a25.3,25.3,0,0,1-6.4-17.58,22.94,22.94,0,0,1,8.8-18.51q8.82-7.25,24.56-8.81V162.07H250v11.56a88.2,88.2,0,0,1,32.12,7.14l-7.29,18.16A83.79,83.79,0,0,0,250,192.88v22.89q15.12,5.82,21.53,10.09a29.31,29.31,0,0,1,9.39,9.39,23.3,23.3,0,0,1,3,11.95Q283.93,259.53,275,267Z" />
                        <rect x="18.95" y="371.49" width="60.42" height="120.37" rx="15.08" />
                        <path d="M455.7,416.94c-2.77-5.69-10-9.94-19.87-6.77L333.72,437.12a11.89,11.89,0,0,0-5.42,3.19l0,0A19.17,19.17,0,0,1,314.67,446H243.08a2.25,2.25,0,0,1-.11-4.49h71.7a14.78,14.78,0,0,0,14.44-17.78A15,15,0,0,0,314.3,412l-65.59-3c-13.81-1.12-19.61-2.72-24.66-4.52C197.19,394.89,183,386,157.22,381c-31.81-6.16-64.82-2.54-64.82-2.54-4,0-7.28,2.84-7.28,6.31v74.6a1.62,1.62,0,0,0,0,.22h0V479a7.21,7.21,0,0,0,6.31,7.37c23,2.73,34.39,3.07,88.54,8.44,37,3.68,68.05,3.37,104.42,3.13,14-.09,19.18-1,26.28-3.76L444,437.47C456.4,432.67,458.56,422.81,455.7,416.94Z" />
                        <path d="M333.52,422.82a2,2,0,0,1,0,.24l68.67-28.15a13.91,13.91,0,0,0-.79-2.66,13.61,13.61,0,0,0-19.24-7.05L323,409.48A19.09,19.09,0,0,1,333.52,422.82Z" />
                        <path d="M333,432.67l97.46-25a14.71,14.71,0,0,0-20.13-11.21l-76.42,31.32A19.13,19.13,0,0,1,333,432.67Z" />
                      </g>
                    </svg>
                  </SvgIcon>
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={4}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center" style={{ marginTop: '-25px' }}># of licensed providers offering care to families using subsidies</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <hr style={{ border: `2px solid ${primaryColor}` }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center">all licensed providers</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Typography variant="body1" align="center" style={{ color: primaryColor }}>
              Access to subsidized child care can be understood by looking at the number of licensed providers offering child care to families using subsidies as a percentage of all licensed providers.
            </Typography>
          </Hidden>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            All families should have access to high-quality child care, regardless of income. That&apos;s not the case for some families who receive child care subsidies, because not all programs accept subsidies.
          </Typography>

          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            The percentage of licensed child care programs that accept subsidies shows this disparity. Use the graphics to explore access
            to subsidized child care in {states[stateCode.toUpperCase()]}.
          </Typography>

          {stateCode.toLowerCase() === 'wi' && (
            <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
              Please note that in Wisconsin, only providers who participate in the state&apos;s QRIS are allowed to accept subsidies.
            </Typography>
          )}
        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q1Header;
